import axios from 'axios';
import { getApiUrl } from './data';

let credentials = {
    username: '',
    password: '',
    pin: '',
    user: null
};

let site = null;

export function setCredentials(username, password, pin, user) {
    credentials = { username, password, pin, user };
    tokenPromise = null;
}

let tokenPromise = null;
let novoice = false;

export function ensureAuth() {
    if (!credentials.username) {
        return Promise.reject(new Error('Credentials not set'));
    }
    if (!tokenPromise) {
        tokenPromise = axios.post(getApiUrl('Authentication/Authenticate'), credentials)
            .then(r => {
                const token = r?.data;
                if (token) {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                }
                return token;
            });
    }
    return tokenPromise;
}

export function ordersSupported() {
    return site?.IsHotelOrder || false;
}

export function setSite(v) {
    site = v;
}

export function getSite() {
    return site;
}

export function currencySymbol() {
    return site?.Country?.Currency?.Symbol || '';
}

export function company() {
    return site?.Company;
}

export function getUserDisplayName() {
    return credentials?.user?.Persona?.FullName || credentials?.user?.UserName || ''
}

export function logOff(vueComponentInstance) {
    const lastSite = getSite();

    // 1. Clear local state
    setCredentials(null, null, null, null);
    setSite(null);
    
    // 2. Clear the authorization header from axios
    delete axios.defaults.headers.common['Authorization'];

    // 3. Redirect using the passed component's router
    if (vueComponentInstance) {
        // NEW: Clear the menu cache from storage
        vueComponentInstance.$store.remove('pos_menu_data');

        if (vueComponentInstance.$router) {
            const query = {};
            if (lastSite?.Oid) {
                query.siteId = lastSite.Oid;
            }
            vueComponentInstance.$router.push({ name: 'login', query: query });
        }
    } else {
        console.error("Logoff function requires a Vue component instance to be passed for redirection.");
    }
}

export function isAuthenticated() {
    // A user is considered authenticated if the user object exists in the credentials.
    return !!credentials.user;
}

export function setNoVoice(v) {
    novoice = v;
}

export function getNoVoice() {
    return novoice;
}

export default {
    ensureAuth,
    setSite,
    getSite,
    ordersSupported,
    currencySymbol,
    company,
    getUserDisplayName,
    logOff,
    isAuthenticated,
    setNoVoice,
    getNoVoice
}